export default "__VITE_ASSET__ee973df6__"